import { useEffect, useRef } from "react";

function useScrollLoad(onLoad, threshold = 100) {
  const containerRef = useRef(null);
  const savedCallback = useRef(onLoad);

  // 始终保持 onLoad 的最新引用，避免频繁重新绑定事件
  useEffect(() => {
    savedCallback.current = onLoad;
  }, [onLoad]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let isThrottled = false;

    const handleScroll = () => {
      // 简单的防抖，防止同一帧内多次计算
      if (isThrottled) return;
      isThrottled = true;

      requestAnimationFrame(() => {
        isThrottled = false;
        const { scrollTop, scrollHeight, clientHeight } = container;

        // 当滚动到底部阈值范围内时，触发回调
        if (scrollHeight - scrollTop - clientHeight <= threshold) {
          if (savedCallback.current) {
            savedCallback.current();
          }
        }
      });
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [threshold]);

  return containerRef;
}

export default useScrollLoad;
